import name from './name'

const selectSliceData = state => state[name]

const selectEmailSent = state => selectSliceData(state).emailSent

export { selectEmailSent }
